import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { HealthProfessionalUser } from '../../../app/authentication';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../constants/endpoints';
import './diagnosis-viewer.css';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { ActionAPI, FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { foundationContext } from '@philips-internal/oswald-ui-foundation';
import { Value } from '@philips-internal/oswald-ui-core/lib/types';
import DiagnosisMenu from '../diagnosis-menu/diagnosis-menu-controller';
import { DeckContext } from '../../commons/Deck/deck-service';
import { DiagnosisViewerAliases, FragmentNames } from '../../../codegen';
import { DateFormatterUtil } from '@philips-emr/health-professional-components/src/utils';
import ShowToast from '../../../utils/toast-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import DiagnosisService from '../diagnosis-service';

@Controller({ component: DiagnosisViewerAliases.LAYOUT_DIAGNOSIS_VIEWER, fragment: FragmentNames.DIAGNOSIS_VIEWER })
export default class DiagnosisViewerController extends DiagnosisMenu {

  @Inject(DiagnosisViewerAliases.FORM_DIAGNOSIS_VIEWER)
  private formApi!: FormAPI;

  @Inject(DiagnosisViewerAliases.FIELD_CLASSIFICATION)
  private fieldClassificationApi!: FieldAPI;

  @Inject(DiagnosisViewerAliases.FIELD_DISEASE)
  private fieldDiseaseApi!: FieldAPI;

  @Inject(DiagnosisViewerAliases.FIELD_SIDE)
  private fieldSideApi!: FieldAPI;

  @Inject(DiagnosisViewerAliases.FIELD_DESCRIPTION)
  private fieldDescriptionApi!: FieldAPI;

  @Inject(DiagnosisViewerAliases.FIELD_TEXT_ENCOUNTER_NUMBER)
  private fieldTextEncounterNumberApi!: FieldAPI;

  @Inject(DiagnosisViewerAliases.ACTION_INACTIVATE_DIAGNOSIS)
  private actionInactivateApi!: ActionAPI;

  @Inject(DiagnosisViewerAliases.ACTION_NEW_DIAGNOSIS)
  private actionNewApi!: ActionAPI;

  @OnMount({ target: DiagnosisViewerAliases.LAYOUT_DIAGNOSIS_VIEWER })
  handleMount(): void {

    InformationBarUtils.collapsedBar = true;

    const { patientId, sequenceNumber } = this.historyService.getCurrentRouteParams();
    const itens = DeckContext.getParamActivate();
    const diagnosis = itens?.find(item => item.sequenceNumber == sequenceNumber );
    const encounterId = diagnosis ? diagnosis.attendanceNumber : this.historyService.getCurrentRouteParams().encounterId;
    const allowInfo = InformationBarUtils.allowInfo && DiagnosisService.isAllowEdit;

    this.formApi.setLoading(true)

    DeckContext.clearParamActivate();
    this.context.set({
      encounterId: encounterId,
      patientId: patientId,
    });

    HttpService.get(Endpoint.GET_DIAGNOSIS, {
      encounterId,
      patientId,
      sequenceNumber
    }
    ).then(response => {
      const res = response.body as Record<string, unknown>;
      const user = foundationContext.getUser() as HealthProfessionalUser;
      const diagnosisDate = DateFormatterUtil.timeStamp(String(res.diagnosisDate));
      const record = { ...this.formApi.getData(), ...res, diagnosisDate } as Record<string, Value>;
      const showInactivate = res.professionalCode === user.physicalPersonId && Boolean(res.showInactivate) && allowInfo;

      this.fieldClassificationApi.setVisible(record.classification != null);
      this.fieldDiseaseApi.setVisible(record.diseaseType != null);
      this.fieldSideApi.setVisible(record.side != null);
      this.fieldDescriptionApi.setVisible(record.description != null);
      this.fieldTextEncounterNumberApi.setVisible(record.attendanceNumber != null);
      this.actionInactivateApi.setEnabled(showInactivate);
      this.formApi.setData(record);
    })
      .catch((error) => ShowToast.open(error?.body.errorMessage, ToastLevel.ERROR))
      .finally(() => {
        this.formApi.setLoading(false)
        this.actionNewApi.setEnabled(allowInfo);
      });
  }

  @OnClick({ target: DiagnosisViewerAliases.ACTION_NEW_DIAGNOSIS })
  handleNewClick(): void {
    this.onNew();
  }

  @OnClick({ target: DiagnosisViewerAliases.ACTION_INACTIVATE_DIAGNOSIS })
  handleInactivateClick(): void {
    this.onInactivate();
  }
}
